class WelcomeModal extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.els.close?.elements?.forEach((el) => {
      this.listeners.add(el, 'click', this.close.bind(this))
    })

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.STORE_SWITCHER.CORRECT_STORE,
      this.onCorrectStore.bind(this),
    )
  }

  onCorrectStore () {
    if (!this.hasWelcomeBeenShown) {
      this.markWelcomeAsShown()
      this.open()
    }
  }

  markWelcomeAsShown () {
    sessionStorage.setItem(this.sessionStorageKey, 'true')
  }

  open () {
    this.setAttribute('aria-hidden', 'false')
    document.body.classList.add('util-SiteOverflowed')
  }

  close () {
    this.setAttribute('aria-hidden', 'true')
    document.body.classList.remove('util-SiteOverflowed')
  }

  get sessionStorageKey () {
    return 'welcomeModalAlreadyShow'
  }

  get hasWelcomeBeenShown () {
    return sessionStorage.getItem(this.sessionStorageKey) === 'true'
  }
}

if (!customElements.get('welcome-modal')) {
  customElements.define('welcome-modal', WelcomeModal)
}
